/**
 * External dependencies
 */

export default class Layout {
  constructor(id, cscom) {
    if (!(this instanceof Layout)) {
      return new Layout(id, cscom);
    }
    this.cscom = cscom;
    this.id = id;

    if (this.id) {
      this.path = `/api/rest/talink/dashboard/widgets/${this.id}`;
    } else {
      this.path = `/api/rest/talink/dashboard/widgets`;
    }
  }

  list(data) {
    return this.cscom.req.get("/api/rest/talink/dashboard/widgets", null, data);
  }

  listAll() {
    return this.cscom.req
      .get("/api/rest/talink/dashboard/widgets", null)
      .then((result) => {
        return result;
      });
  }

  update(body) {
    return this.cscom.req.put(this.path, body).then((result) => {
      return result;
    });
  }

  add(body) {
    return this.cscom.req.post(this.path, body).then((result) => {
      return result;
    });
  }

  remove() {
    return this.cscom.req.del(this.path).then((result) => {
      return result;
    });
  }
}
